import {
  Flex,
  useDisclosure,
  Box,
  position,
  Stack,
  Divider,
  useColorMode,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { sidebarisexpandAtom, panelAtom } from "states/recoil";
import {
  IoMdHome,
  IoMdArrowRoundBack,
  IoMdArrowRoundForward,
  IoMdDocument,
  IoMdBookmarks,
  IoMdCar,
  IoIosAddCircle,
  IoIosSpeedometer,
  IoIosWallet,
  IoMdPeople,
} from "react-icons/io";
import Logo from "assets/img/logo-papeda.png";

import Toggle from "components/ui/Toggle";

const SidebarSekretariat = () => {
  const { colorMode } = useColorMode();
  // const { getButtonProps, getDisclosureProps, sidebarisexpandGet } = useDisclosure();

  const sidebarisexpandGet = useRecoilValue(sidebarisexpandAtom);
  const sidebarisexpandSet = useSetRecoilState(sidebarisexpandAtom);
  const panelSet = useSetRecoilState(panelAtom);
  const panelGet = useRecoilValue(panelAtom);

  console.log(sidebarisexpandGet);

  const backgroundColorMenu = (panelName) => {
    if (panelName === panelGet) {
      return colorMode === "light" ? "gray.800" : "gray.100";
    } else {
      return "transparent";
    }
  };

  const textColorMenu = (panelName) => {
    if (panelName === panelGet) {
      return colorMode === "light" ? "gray.100" : "gray.800";
    } else {
      return colorMode === "light" ? "gray.800" : "gray.100";
    }
  };

  return (
    <Box>
      <motion.div
        // {...getDisclosureProps()}
        hidden={false}
        initial={false}
        // onAnimationStart={() => sidebarisexpandSet(!sidebarisexpandGet)}
        animate={{ width: sidebarisexpandGet ? 240 : 70 }}
        style={{
          overflow: "hidden",
          height: "calc(100vh - 40px)",
          top: 20,
          left: "0",
          margin: "0px 20px 20px 20px",
          padding: "24px 16px 16px 16px",
          borderRadius: "10px",
          backgroundColor: colorMode === "light" ? "#ffffff" : "#2D3748",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          border: "1px solid",
          borderColor: "#E2E8F0",
        }}
      >
        <Flex
          direction={"column"}
          justifyContent={"space-between"}
          alignItems={"space-between"}
          height={"100%"}
        >
          <Stack>
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"16px"}
              alignContent={"flex-start"}
              borderRadius={"10px"}
              p={sidebarisexpandGet ? "10px" : "0px"}
              color={textColorMenu("logo")}
              fontWeight={"extrabold"}
              onClick={() => panelSet("manajemenPengguna")}
            >
              <Flex gap={"8px"}>
                <img src={Logo} alt="logo" width={"100%"} />
              </Flex>
            </Flex>
            <Box
              h={"3px"}
              bg={colorMode === "light" ? "whiteAlpha.800" : "gray.900"}
              mx={"-20px"}
              my={"12px"}
            />
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"flex-start"}
              bg={backgroundColorMenu("manajemenPengguna")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("manajemenPengguna")}
              fontWeight={"medium"}
              onClick={() => panelSet("manajemenPengguna")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoMdPeople fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Manajemen Pengguna" : ""}
              </Flex>
            </Flex>
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              bg={backgroundColorMenu("penyaluranTKD")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("penyaluranTKD")}
              fontWeight={"medium"}
              onClick={() => panelSet("penyaluranTKD")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoIosSpeedometer fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Penyaluran TKD" : ""}
              </Flex>
            </Flex>
            {/* <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              bg={backgroundColorMenu("penyaluranTKD")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("penyaluranTKD")}
              fontWeight={"medium"}
              onClick={() => panelSet("penyaluranTKD")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoIosSpeedometer fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Penyaluran TKD" : ""}
              </Flex>
            </Flex>
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              bg={backgroundColorMenu("admPerjadin")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("admPerjadin")}
              fontWeight={"medium"}
              onClick={() => panelSet("admPerjadin")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoMdCar fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Adm. Perjadin" : ""}
              </Flex>
            </Flex>
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              bg={backgroundColorMenu("admAnggaran")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("admAnggaran")}
              fontWeight={"medium"}
              onClick={() => panelSet("admAnggaran")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoIosWallet fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Adm. Anggaran" : ""}
              </Flex>
            </Flex> 
            <Flex
              justifyContent={sidebarisexpandGet ? "flex-start" : "center"}
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              bg={backgroundColorMenu("manajemenpegawai")}
              borderRadius={"10px"}
              p={"10px"}
              color={textColorMenu("manajemenpegawai")}
              fontWeight={"medium"}
              onClick={() => panelSet("manajemenpegawai")}
            >
              <Flex gap={"8px"}>
                <button style={{ marginTop: "-3px" }}>
                  <IoMdPeople fontSize={"24px"} />
                </button>
                {sidebarisexpandGet ? "Manajemen Data Pegawai" : ""}
              </Flex>
            </Flex> */}
          </Stack>
          <Flex
            direction={"column"}
            justifyContent={"space-between"}
            alignItems={sidebarisexpandGet ? "flex-start" : "center"}
            gap={"8px"}
          >
            {/* <Flex
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              borderRadius={"10px"}
              color={colorMode === "light" ? "gray.800" : "gray.100"}
              fontWeight={"medium"}
            >
              <Toggle />
              {sidebarisexpandGet ? (
                <Text
                  variant={colorMode === "dark" ? "dark" : undefined}
                  pt="8px"
                >
                  {colorMode === "light" ? "Dark Mode" : "Light Mode"}
                </Text>
              ) : (
                ""
              )}
            </Flex> */}
            <Flex
              gap={"12px"}
              fontSize={"14px"}
              alignContent={"space-between"}
              borderRadius={"10px"}
              color={colorMode === "light" ? "gray.800" : "gray.100"}
              fontWeight={"medium"}
            >
              <button onClick={() => sidebarisexpandSet(!sidebarisexpandGet)}>
                {sidebarisexpandGet ? (
                  <IconButton
                    icon={
                      colorMode === "light" ? (
                        <IoMdArrowRoundBack fontSize={"24px"} />
                      ) : (
                        <IoMdArrowRoundBack fontSize={"24px"} />
                      )
                    }
                  />
                ) : (
                  <IconButton
                    icon={
                      colorMode === "light" ? (
                        <IoMdArrowRoundForward fontSize={"24px"} />
                      ) : (
                        <IoMdArrowRoundForward fontSize={"24px"} />
                      )
                    }
                  />
                )}
              </button>
              {sidebarisexpandGet ? (
                <Text
                  variant={colorMode === "dark" ? "dark" : undefined}
                  pt="8px"
                >
                  Perkecil Menu
                </Text>
              ) : (
                ""
              )}
            </Flex>
          </Flex>
        </Flex>
      </motion.div>
    </Box>
  );
};

export default SidebarSekretariat;
